// src/utils/ScrollToTop.jsx (or anywhere you prefer)
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToPosition } from "./scrollContainer";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToPosition(0, "smooth");
  }, [pathname]);

  return null;
};

export default ScrollToTop;
